module.exports = __webpack_public_path__ + "images/emoji/articulated_lorry.f18ee21545b926c4e8f6.png";